import { useRef, useState } from 'react'
import SalaryBreakdownTab from './SalaryBreakdownTab'
import DeductionsTab from './DeductionsTab'
import { toast } from 'react-toastify'
import CustomDeductionModal from './CustomDeductionModal'
import PfaSetupModal from './PfaSetupModal'
import EditDeductionModal from './EditDeductionModal'
import usePayrollEssentials from 'hooks/usePayrollEssentials'
import { ButtonLoader } from 'components/__new/common/form'
import Maybe from 'components/__new/common/Maybe'

const CreatePayStructure = () => {
    const {history, SubPageTooltip, lettersRegex, useSelector} = usePayrollEssentials();
    const { createPayStructureLoading: createLoading} = useSelector((state) => state.entities.payrollSetup);

    const breakdownSubmitRef = useRef();
    const deductionSubmitRef = useRef();

    const [current, setCurrent] = useState(0);
    const [form, setForm] = useState({
        name: "",
        salary_breakdown: [
        {id: Math.random(), salary_component: 'BASIC', percentage: '0', is_default: true},
        {id: Math.random(), salary_component: 'HOUSING', percentage: '0', is_default: true},
        {id: Math.random(), salary_component: 'TRANSPORT', percentage: '0', is_default: true},
    ]
    });
    const [modalOpen, setModalOpen] = useState(false);

    const items = [
        { title: 'Salary Breakdown', Component: <SalaryBreakdownTab breakdownSubmitRef={breakdownSubmitRef} form={form} setForm={setForm} setCurrent={setCurrent} /> },
        { title: 'Deduction', Component: <DeductionsTab deductionSubmitRef={deductionSubmitRef} modalOpen={modalOpen} setModalOpen={setModalOpen} /> }
    ]

    const onProceed = () => {
        if(!form?.name) {
            toast.error('Please enter a pay structure name')
        } else if(!lettersRegex.test(form?.name)) {
            toast.error('Pay structure name must contain letters')
        } else {
            breakdownSubmitRef?.current?.click()
        }
    }

    return (
        <>
            <EditDeductionModal />
            <CustomDeductionModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
            <div className="w-full">
                <div className="border-b flex-btw items-center flex-wrap lg:flex-nowrap pb-4 mb-5 lg:mb-0">
                    <div className="w-full lg:w-2/4">
                        <div className="font-medium prl-bold flex">
                            Create a Payroll structure
                            <SubPageTooltip
                                text={<span>This payroll setup is required for <br /> both Net Payroll and Gross Payroll.</span>}
                            />
                        </div>
                        <p className="mb-1 mt-1.5 text-xs lt-gray">Configure a new payroll structure here.</p>
                    </div>

                        <div className="payroll-setup-subpage-action">
                            <Maybe condition={current === 0}>
                                <button onClick={onProceed} className="btn btn-md btn-ep-primary">
                                    Next
                                </button>
                            </Maybe>
                            
                            <Maybe condition={current === 1}>
                                <ButtonLoader loading={createLoading} disabled={current !== 1} onClick={() => deductionSubmitRef?.current?.click()} className="btn btn-md btn-ep-primary">
                                    {createLoading ? "Configuring" : "Create"}
                                </ButtonLoader>
                            </Maybe>
                            
                            <button
                                className="btn btn-md btn-white bg-white ml-5"
                                onClick={() => {
                                    if(current === 0) {
                                        history.push("/payroll-configuration/pay-structure")
                                    } else {
                                        setCurrent(0);
                                    }
                                }}>
                                {current === 0 ? "Cancel" : "Back"}
                            </button>
                        </div>
                </div>


                <form onSubmit={(e) => e.preventDefault()}>
                <div className="border-b w-full pt-7 lg:pt-0">
                    <div className="structure-wrap">
                        <p className="structure-text">Structure Name</p>
                        <div className="structure-input">
                        <input minLength={3} maxLength={50} className="form-input" type="text" required placeholder="Enter Structure Name"
                        value={form?.name || ""} onChange={(e) => { setForm({...form, name: e.target.value}) }} />
                        </div>
                    </div>
                </div>
                    <button ref={breakdownSubmitRef} style={{display: 'none'}} type="submit">Continue</button>
                </form>
                <div className='w-full pt-4'>
                        <div className="w-full bg-ep-primary-light-100 py-4 pl-4 flex items-center">
                        {items.map(({title},idx) => {
                        const isActive = current === idx
                        return <div key={idx} className={`mr-6 text-sm ${isActive ? 'relative text-ep-primary-600 font-medium' : 'text-[#7a8096]'}`}>
                                <p className="mb-0">{title}</p>
                            {isActive && <div style={{height: '2px', bottom: '-8px'}} className='absolute w-full left-0 bg-ep-primary-600' />}
                        </div>
                        })}
                        </div>
                    <div className="mt-6">{items[current].Component}</div>
                </div>
            </div>
            <PfaSetupModal />
    </>
    )
}

export default CreatePayStructure